import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { setColor } from "../../../../../assets/styles/styles";
import { hexToRGBA } from "../../../../../utils/generalUtils";

const Modal = ({ isOpen, chartTitle, onClose, children }) =>
    isOpen && (
        <ModalOverlay>
            <ModalContainer>
                <ModalHeader>
                    <ModalTitle>{chartTitle}</ModalTitle>
                    <CloseButton onClick={onClose}>✕</CloseButton>
                </ModalHeader>
                <ModalBody>{children}</ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );

export default Modal;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${hexToRGBA(setColor.black, 0.5)};
    backdrop-filter: blur(64px);
    -webkit-backdrop-filter: blur(64px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
`;

const ModalContainer = styled.div`
    display: flex;
    width: 1000px;
    max-height: 80vh;
    padding: 30px 40px 0px 40px;
    flex-direction: column;
    align-items: center;
    gap: 22px;
    border-radius: 10px;
    border: 1px solid ${setColor.brightVioletTransparent};
    overflow-y: auto;
    background: rgba(46, 39, 73, 0.5);

    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    @media (max-width: 1440px) {
        max-height: 80vh;
    }
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding: 15px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const ModalTitle = styled.div`
    color: var(--Text-Primary, #fbfcff);
    font-family: "Barlow";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    color: var(--Text-Primary, #fbfcff);
    font-size: 20px;
    cursor: pointer;
    padding: 0;
`;

const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
`;
